import React from 'react';
import PropTypes from 'prop-types';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { SegmentContext } from './Context';
import { ConnectedFlightsManagerLegMobile } from '../../FlightsManagerLegMobile';
import { DateFieldRoundTrip } from '../../MobileFields/DateFieldRoundTrip';
import { SearchSegment } from '../../../../models';
import { getSegments, displayFaresInCalendar } from '../../../../redux/currentSearch/selectors';
import { ConnectedFaresProvider } from '../../../../components/Calendar/Context/FaresProvider';

export const SegmentManagerRoundTripContent = ({ segments, displayFaresInCalendar }) => {
    const index = 0;
    const segment = segments[index];

    return (
        <SegmentContext.Provider value={{ segment }}>
            <ConnectedFlightsManagerLegMobile index={index} />
            <ConnectedFaresProvider
                segmentId={segment.id}
                displayFaresInCalendar={displayFaresInCalendar}
            >
                <DateFieldRoundTrip />
            </ConnectedFaresProvider>
        </SegmentContext.Provider>
    );
};

SegmentManagerRoundTripContent.propTypes = {
    segments: PropTypes.arrayOf(SearchSegment),
    displayFaresInCalendar: PropTypes.bool.isRequired,
};

SegmentManagerRoundTripContent.defaultProps = {
    segments: [],
};

export const SegmentManagerRoundTrip = ({ segments, displayFaresInCalendar }) => {
    return (
        <React.Fragment>
            <SegmentManagerRoundTripContent
                segments={segments}
                displayFaresInCalendar={displayFaresInCalendar}
            />
        </React.Fragment>
    );
};

SegmentManagerRoundTrip.propTypes = {
    segments: PropTypes.arrayOf(SearchSegment),
    displayFaresInCalendar: PropTypes.bool.isRequired,
};

SegmentManagerRoundTrip.defaultProps = {
    segments: [],
};

const mapStateToPropsSelector = createStructuredSelector({
    segments: getSegments,
    displayFaresInCalendar: displayFaresInCalendar,
});

export const ConnectedSegmentManagerRoundTrip = connect(mapStateToPropsSelector)(
    SegmentManagerRoundTrip,
);
